var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { Divider, LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { invoice as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import { useNotify } from '../../../hooks/notificationHook';
import { useInvoiceItemColumns } from '../../../hooks/useColumns';
import PageLayout from '../../atoms/PageLayout';
import MaterialTable from '../../MaterialTable';
import InvoiceForm from './InvoiceForm';
import InvoiceDownloadButton from '../../organisms/InvoiceDownloadButton';
import SendMailButton from './SendMailButton';
import PayButton from './PayButton';
import TaiwanApiResponseResendButtons from './TaiwanApiResponseResendButtons';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 24px;\n\n  .checkbox-field {\n    display: flex;\n    align-items: center;\n  }\n"], ["\n  padding: 0 24px;\n\n  .checkbox-field {\n    display: flex;\n    align-items: center;\n  }\n"])));
var buildRequestInvoiceItem = function (item) { return ({
    description: item.description,
    quantity: item.quantity,
    weight: item.weight,
    beans_amount: item.beansAmount,
    typica_handling_amount: item.typicaHandlingAmount,
    taxed_misc_amount: item.taxedMiscAmount,
    non_taxed_misc_amount: item.nonTaxedMiscAmount,
    tax: item.tax,
    sub_total: item.subTotal,
}); };
var AdminInvoiceDetailPage = function () {
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var t = useTranslation().t;
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(), invoice = _c[0], setInvoice = _c[1];
    var _d = React.useState(0), reloadCount = _d[0], setReloadCount = _d[1];
    var _e = React.useState([]), invoiceItems = _e[0], setInvoiceItems = _e[1];
    var getInvoice = useRequest(api.get);
    var createInvoiceItem = useRequest(api.createItem);
    var updateInvoiceItem = useRequest(api.updateItem);
    var deleteInvoiceItem = useRequest(api.destroyItem);
    var notify = useNotify();
    var taxName = (invoice === null || invoice === void 0 ? void 0 : invoice.roaster.country.taxName) || '';
    var invoiceItemColumns = useInvoiceItemColumns({ taxName: taxName });
    var columns = React.useMemo(function () {
        if (!invoice)
            return [];
        if (invoice.version === 'v0') {
            return [
                invoiceItemColumns.description,
                invoiceItemColumns.weight,
                invoiceItemColumns.subTotal(invoice.currency),
            ];
        }
        var columns = [
            invoiceItemColumns.description,
            invoiceItemColumns.weight,
            invoiceItemColumns.beansAmount(invoice.currency),
            invoiceItemColumns.typicaHandlingAmount(invoice.currency),
            invoiceItemColumns.nonTaxedMiscAmount(invoice.currency),
            invoiceItemColumns.taxedMiscAmount(invoice.currency),
            invoiceItemColumns.tax(invoice.currency),
            invoiceItemColumns.subTotal(invoice.currency),
        ];
        if (invoice.roaster.country.code === 'JP') {
            columns.push(invoiceItemColumns.transferDate);
        }
        return columns;
    }, [invoiceItemColumns, invoice]);
    var title = React.useMemo(function () {
        if (!invoice)
            return '';
        return t('pages.invoice.title', {
            orderIds: invoice.orders.map(function (order) { return "#".concat(order.id); }).join(', ') || '',
        });
    }, [t, invoice]);
    var handleChangeInvoice = React.useCallback(function (invoice) {
        setInvoice(invoice);
        var nextItems = (invoice.items || []).map(function (item) {
            // material-table editableはcolumnsにobject含んでると落ちるので
            // 編集対象外のorderItemはnullにする
            return __assign(__assign({}, item), { orderItem: null, invoice: null });
        });
        setInvoiceItems(nextItems);
    }, []);
    var handleCreate = React.useCallback(function (invoiceItem) { return __awaiter(void 0, void 0, void 0, function () {
        var request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!invoice)
                        return [2 /*return*/];
                    request = {
                        invoice_item: __assign(__assign({}, buildRequestInvoiceItem(invoiceItem)), { invoice_id: invoice.id }),
                    };
                    return [4 /*yield*/, createInvoiceItem(request)];
                case 1:
                    response = _a.sent();
                    if (!response) {
                        setReloadCount(reloadCount + 1);
                        return [2 /*return*/];
                    }
                    setReloadCount(reloadCount + 1);
                    return [2 /*return*/];
            }
        });
    }); }, [invoice, reloadCount, createInvoiceItem, setReloadCount]);
    var handleUpdate = React.useCallback(function (invoiceItem) { return __awaiter(void 0, void 0, void 0, function () {
        var data, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = {
                        id: invoiceItem.id,
                        invoice_item: buildRequestInvoiceItem(invoiceItem),
                    };
                    return [4 /*yield*/, updateInvoiceItem(data)];
                case 1:
                    response = _a.sent();
                    if (!response) {
                        setReloadCount(reloadCount + 1);
                        return [2 /*return*/];
                    }
                    setReloadCount(reloadCount + 1);
                    return [2 /*return*/];
            }
        });
    }); }, [updateInvoiceItem, reloadCount]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getInvoice(id)];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        handleChangeInvoice(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, getInvoice, handleChangeInvoice, reloadCount]);
    var handleDelete = React.useCallback(function (_a) {
        var id = _a.id;
        return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, deleteInvoiceItem(id)];
                    case 1:
                        response = _b.sent();
                        if (!response) {
                            setReloadCount(reloadCount + 1);
                            return [2 /*return*/];
                        }
                        setReloadCount(reloadCount + 1);
                        notify('success', [t('messages.deleteSuccess')]);
                        return [2 /*return*/];
                }
            });
        });
    }, [t, deleteInvoiceItem, reloadCount, notify]);
    if (!invoice)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { title: title, actions: React.createElement(React.Fragment, null,
            invoice.taiwanApiResponse && (React.createElement(TaiwanApiResponseResendButtons, { invoice: invoice, onChange: handleChangeInvoice })),
            React.createElement(PayButton, { invoice: invoice, onChange: handleChangeInvoice }),
            React.createElement(SendMailButton, { id: invoice.id }),
            React.createElement(InvoiceDownloadButton, { id: invoice.id, disabled: parseFloat(invoice.total || '0') <= 0 })) },
        React.createElement(Container, null,
            React.createElement(InvoiceForm, { invoice: invoice, onChange: handleChangeInvoice })),
        React.createElement(Divider, null),
        React.createElement(MaterialTable, { model: "invoiceItem", emptyValue: "(blank)", isLoading: loading, columns: columns, data: invoiceItems, editable: {
                onRowAdd: handleCreate,
                onRowUpdate: handleUpdate,
                onRowDelete: handleDelete,
            } })));
};
export default AdminInvoiceDetailPage;
var templateObject_1;
